<div
  (window:scroll)="onScroll($event)"
  class="search-wrapper"
  [class.is-stuck]="isStuck"
>
  <form class="Search" [class.is-stuck]="isStuck" data-testid="search">
    <mat-form-field appearance="outline">
      <input #searchInput
            type="text"
            aria-label="Search"
            i18n-aria-label="@@search.input.aria-label"
            placeholder="Search"
            i18n-placeholder="@@search.input.placeholder"
            matInput
            data-testid="searchInput"
            [formControl]="myControl"
            [matAutocomplete]="auto" />
      <mat-icon matSuffix>search</mat-icon>
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onSelect($event)">
        @if (filteredOptions && filteredOptions.length) {
          @for (group of filteredOptions; track group) {
            <mat-optgroup [label]="getLabel(group)">
              @for (option of group; track option) {
                <mat-option [value]="option" class="ras-searchbox-item">
                  <div class="option-value">
                      <span class="result-field-value" [innerHTML]="option.value"></span>
                  </div>
                </mat-option>
              }
            </mat-optgroup>
          }
        }
        @if (filteredOptions && !filteredOptions.length && searchText) {
          <mat-option disabled innerHTML="no data" i18n="@@search.input.no-results">No results found</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    @if (withFilters()) {
      <button
        mat-icon-button
        aria-label="Filter results"
        (click)="eventService.notifyFilterClicked()"
        class="filter-button"
        [class.is-stuck]="isStuck"
        data-testid="filterButton"
      >
        <mat-icon fontSet="material-icons-outlined">filter_alt</mat-icon>
        <div class="filter-count">{{chipsService.chips().length}}</div>
      </button>
    }
  </form>
</div>